(() => {
  const rootPath = window.Shopify?.routes?.root || '/';
  const key = 'pm:reorder:review:v1';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:window.Shopify?.currency?.active || 'USD'}).format(Number(cents) / 100);
  function publicProperties(value) {
    const pairs = Array.isArray(value) ? value : Object.entries(value || {});
    return Object.fromEntries(pairs.filter(pair => Array.isArray(pair) && pair[0] && !String(pair[0]).startsWith('_')).map(([name,value]) => [String(name),String(value)]));
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-pm-reorder]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    try {
      const payload = JSON.parse(link.dataset.pmReorder);
      if (!payload.handle || !payload.variantId) return;
      payload.properties = publicProperties(payload.properties);
      payload.time = Date.now();
      sessionStorage.setItem(key, JSON.stringify(payload));
    } catch (_) { /* Ordinary product link still works if storage is unavailable. */ }
  });

  function enhance(root) {
    if (!root) return;
    const info = root.querySelector('.product__info-container');
    const buy = info?.querySelector('product-form');
    if (!info || !buy) return;
    let more = info.querySelector(':scope > .pm-purchase-details');
    if (!more) {
      more = document.createElement('div'); more.className = 'pm-purchase-details';
      let anchor = buy;
      while (anchor.parentElement !== info && anchor.parentElement) anchor = anchor.parentElement;
      anchor.after(more);
    }
    // Move the live components, never copies: form bindings and price calculations remain intact.
    root.querySelectorAll('[data-pm-finishing-touches], .pm-meal-builder__nutrition').forEach(node => {
      if (!more.contains(node)) more.append(node);
    });
    root.querySelectorAll('[data-pm-meal-builder]').forEach(builder => {
      builder.classList.toggle('pm-builder-empty', !builder.querySelector('variant-selects, [data-pm-side-pickers]'));
    });
    root.querySelectorAll('[data-pm-finishing-touches]').forEach(touches => {
      const included = touches.querySelector('[data-pm-included-details]');
      const outer = touches.querySelector('[data-pm-finishing-details]');
      if (included && outer && outer.contains(included)) touches.insertBefore(included, outer);
      if (included) {
        included.classList.add('pm-included-compact');
      }
      if (outer && Number(touches.dataset.availableCount || 0) === 0) outer.hidden = true;
      const title = touches.querySelector('.pm-finishing-touches__title');
      if (title && title.textContent !== 'Add extras') title.textContent = 'Add extras';
    });
  }

  let frame = 0;
  function schedule() {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      document.querySelectorAll('#MainContent product-info, quick-add-modal product-info').forEach(enhance);
    });
  }
  schedule();
  // The older Favorites dialog uses the same review-first route for order history.
  document.querySelectorAll('[data-panel="orders"] [data-line-item]').forEach(line => {
    try {
      const payload = JSON.parse(line.dataset.linePayload);
      const props = Array.isArray(payload.properties) ? Object.fromEntries(payload.properties) : payload.properties || {};
      if (props._pm_add_on) { line.hidden = true; return; }
      line.querySelectorAll('.purefect-saved-meals__select, .purefect-saved-meals__line-meta').forEach(el => {el.hidden = true;});
      if (payload.handle && payload.variantId) {
        const link = document.createElement('a');
        link.href = rootPath + 'products/' + encodeURIComponent(payload.handle) + '?variant=' + encodeURIComponent(payload.variantId);
        link.dataset.pmReorder = JSON.stringify(payload);
        link.textContent = 'Review current options & order again →';
        line.append(link);
      }
    } catch (_) {}
  });
  document.querySelectorAll('[data-panel="orders"] .purefect-saved-meals__footer').forEach(el => {el.hidden = true;});
  new MutationObserver(records => {
    if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1))) schedule();
  }).observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true});
  document.addEventListener('shopify:section:load', schedule);

  // Historical configurations must pass through today's product controls and explicit review.
  let saved;
  try { saved = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) {}
  const productRoot = document.querySelector('#MainContent product-info');
  const currentHandle = location.pathname.split('/products/')[1]?.split('/')[0];
  if (!saved || !productRoot || saved.handle !== currentHandle || Date.now() - saved.time > 1800000) return;
  try { sessionStorage.removeItem(key); } catch (_) {}
  const props = publicProperties(saved.properties);
  const report = [];
  const banner = document.createElement('section');
  banner.className = 'pm-reorder-review'; banner.setAttribute('aria-label', 'Review your previous order');
  productRoot.classList.add('pm-reorder-pending');
  const heading = document.createElement('strong'); heading.textContent = 'Review your order again';
  const description = document.createElement('p'); description.textContent = 'Check the current price, size, sides, and extras below. Nothing has been added yet.';
  const list = document.createElement('ul');
  const quantity = productRoot.querySelector('input[name="quantity"]');
  if (quantity) {
    const requested = Math.max(1, Math.min(99, Number(saved.quantity) || 1));
    const max = Number(quantity.max || 99);
    quantity.value = String(Math.min(requested, max));
    quantity.dispatchEvent(new Event('change', {bubbles:true}));
  }
  ['Side One','Side Two'].forEach(name => {
    const controls = [...productRoot.querySelectorAll('input[data-pm-real-side]')].filter(input => input.name === 'properties[' + name + ']');
    const previous = props[name];
    const match = controls.find(input => input.value === previous && !input.disabled);
    if (match) { match.checked = true; match.dispatchEvent(new Event('change', {bubbles:true})); report.push(name + ': ' + previous); }
    else if (previous || controls.length) report.push(name + ': please choose again — the previous option may have changed.');
  });
  if (props['Finishing Touches']) {
    const requested = props['Finishing Touches'].split(',').map(name => name.trim());
    const inputs = [...productRoot.querySelectorAll('[data-pm-finishing-touch]')];
    requested.forEach(name => {
      const input = inputs.find(input => input.dataset.touchLabel === name && !input.disabled);
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', {bubbles:true})); report.push('Extra: ' + name + ' (current price applies)'); }
      else report.push('Review extra: ' + name + ' is no longer offered in the same way.');
    });
    const extras = productRoot.querySelector('[data-pm-finishing-details]'); if (extras) extras.open = true;
  }
  Object.entries(props).filter(([name]) => !['Side One','Side Two','Finishing Touches'].includes(name) && !name.startsWith('Nutrition')).forEach(([name,value]) => report.push('Previously — ' + name + ': ' + value));
  report.forEach(text => { const li = document.createElement('li'); li.textContent = text; list.append(li); });
  const checkLabel = document.createElement('label');
  const check = document.createElement('input'); check.type = 'checkbox'; check.disabled = true;
  checkLabel.append(check, ' I have reviewed the current size, price, sides, extras, and pickup details.');
  const pickup = document.createElement('button'); pickup.type = 'button'; pickup.className = 'pm-reorder-pickup'; pickup.textContent = 'Check pickup date & location';
  pickup.addEventListener('click', () => document.dispatchEvent(new CustomEvent('pm:delivery-calendar:open', { detail: { trigger: pickup } })));
  check.addEventListener('change', () => productRoot.classList.toggle('pm-reorder-pending', !check.checked));
  banner.append(heading,description,list,pickup,checkLabel);
  productRoot.querySelector('.product__title')?.after(banner);
  const guard = event => {
    if (check.checked && !check.disabled) return;
    event.preventDefault(); event.stopImmediatePropagation();
    banner.scrollIntoView({block:'center',behavior:'auto'}); check.focus({preventScroll:true});
  };
  document.addEventListener('click', event => {
    if (event.target.closest('.product-form__submit, [data-pm-mobile-action-button], .pm-ux-purchase-tray button, .shopify-payment-button')) guard(event);
  },true);
  productRoot.addEventListener('submit', guard, true);
  productRoot.addEventListener('change', event => { if (event.target !== check) { check.checked = false; productRoot.classList.add('pm-reorder-pending'); } });
  fetch(rootPath + 'products/' + encodeURIComponent(saved.handle) + '.js', {headers:{Accept:'application/json'}})
    .then(response => {if (!response.ok) throw Error(); return response.json();})
    .then(product => {
      const variant = product.variants.find(v => String(v.id) === String(saved.variantId));
      const message = !variant?.available ? 'Your previous size is unavailable. Choose an available option before adding.'
        : Number.isFinite(Number(saved.price)) && Number(variant.price) !== Number(saved.price) ? 'Price changed: previously ' + money(saved.price) + '; now ' + money(variant.price) + ' before sides or extras.'
        : 'Current base price: ' + money(variant.price) + '. Review any side or extra charges below.';
      const p = document.createElement('p'); p.textContent = message; banner.insertBefore(p,list);
    }).catch(() => { description.textContent += ' We could not compare the old price; review the price shown on this page.'; })
    .finally(() => { check.checked = false; check.disabled = false; productRoot.classList.add('pm-reorder-pending'); });
})();


(() => {
 const dock=document.querySelector('[data-reorder-dock]');if(!dock)return;
 const panel=dock.querySelector('[data-reorder-panel]'),trigger=panel.querySelector('summary'),key='pm:reorder:expanded:v1';
 const close=(focus=false)=>{panel.open=false;if(focus)trigger.focus({preventScroll:true});};
 try{panel.open=sessionStorage.getItem(key)==='true';}catch{}
 panel.addEventListener('toggle',()=>{trigger.setAttribute('aria-expanded',String(panel.open));try{sessionStorage.setItem(key,String(panel.open));}catch{}});
 trigger.setAttribute('aria-expanded',String(panel.open));
 dock.querySelector('[data-reorder-close]').addEventListener('click',()=>close(true));
 document.addEventListener('keydown',e=>{if(e.key==='Escape'&&panel.open){close(dock.contains(document.activeElement));}});
 document.addEventListener('click',e=>{
  if(e.target.closest('[data-pm-reorder]')){close();try{sessionStorage.setItem(key,'false');}catch{}}
  if(e.target.closest('.pm-hub-selector__launcher,.pm-delivery-calendar__launcher'))close();
 });
 const position=()=>{
  const rects=[...document.querySelectorAll('.pm-hub-selector__launcher,.pm-delivery-calendar__launcher')].filter(n=>n.getClientRects().length&&getComputedStyle(n).visibility!=='hidden').map(n=>n.getBoundingClientRect());
  if(!rects.length){dock.style.removeProperty('--pm-reorder-right');dock.style.removeProperty('--pm-reorder-bottom');return;}
  const right=innerWidth-Math.min(...rects.map(r=>r.left))+12;
  dock.style.setProperty('--pm-reorder-right',right+'px');
  dock.style.setProperty('--pm-reorder-bottom',Math.max(12,innerHeight-Math.max(...rects.map(r=>r.bottom)))+'px');
 };
 let frame;const schedule=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(position);};
 new ResizeObserver(schedule).observe(document.body);
 window.addEventListener('resize',schedule);window.addEventListener('pageshow',schedule);position();
})();
